import {LoggerConfig, RealUserMonitoringConfig, RemoteLoggingConfig} from '@/logger';
import {
  CompositeLoggingStrategy,
  ConsoleLoggingStrategy,
  LoggingStrategy,
  NoOpLoggingStrategy,
  RemoteLoggingStrategy
} from '@/logger/strategies';
import {DatadogProvider, DatadogRumProvider, RemoteLoggingProvider, RumProvider} from "@/logger/providers";

export function selectStrategy(config: LoggerConfig): LoggingStrategy {
  const strategies: LoggingStrategy[] = [];
  // Always add console for local development
  if (config.enableConsole) {
    strategies.push(new ConsoleLoggingStrategy(config));
  }

  // Add remote logging for non-local environments
  if (config.remoteLogging?.enabled) {
    const provider = createRemoteLogProvider(config.remoteLogging);
    provider.initialize();
    strategies.push(new RemoteLoggingStrategy(provider, config));
  }
  // Add RUM logging for non-local environments
  if (config.realUserMonitoring?.enabled) {
    const provider = createRumLogProvider(config.realUserMonitoring);
    provider.initialize();
    strategies.push(new RemoteLoggingStrategy(provider, config));
  }

  // Return appropriate strategy
  if (strategies.length === 0) {
    return new NoOpLoggingStrategy();
  } else if (strategies.length === 1) {
    return strategies[0];
  } else {
    return new CompositeLoggingStrategy(strategies);
  }
}

export function createRemoteLogProvider(remoteConfig: RemoteLoggingConfig): RemoteLoggingProvider {
  if (remoteConfig.provider === 'datadog') {
    return new DatadogProvider(remoteConfig.config);
  }
  throw new Error(`Unknown remote logging provider: ${remoteConfig.provider}`);
}

export function createRumLogProvider(rumConfig: RealUserMonitoringConfig): RumProvider {
  if (rumConfig.provider === 'datadog') {
    return new DatadogRumProvider(rumConfig.config);
  }
  throw new Error(`Unknown RUM provider: ${rumConfig.provider}`);
}
